// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"448":"7e41542a2a8121445a4f","565":"4016b9abcf28c743de06","588":"f45884d7688301d5499f","591":"8e28c4e31a511b57c886","900":"1736b46798a71c4b861b"}[chunkId] + ".js";
};